/**
 * Quantas linhas a caixa de edição da descrição abre.
 *
 * <p>Existe por um defeito que ninguém consegue não notar: fechada, a descrição mostra
 * o texto inteiro e cresce com ele; aberta, ela caía numa janela fixa de cinco linhas
 * com barra de rolagem. Clicar para editar <b>encolhia</b> o que se estava lendo — o
 * contrário do que a ação promete.
 *
 * <p>Agora a caixa abre do tamanho do texto, entre um piso e um teto:
 *
 * <ul>
 *   <li><b>Piso de 6</b>: uma caixa de duas linhas para uma descrição de duas linhas
 *       fica apertada para escrever a terceira — e o campo existe para ser escrito.</li>
 *   <li><b>Teto de 24</b>: passando disso a caixa toma o modal inteiro e esconde o
 *       checklist e a conversa. Daí para cima, quem rola é ela.</li>
 * </ul>
 *
 * <p>Conta as quebras de linha, não o texto reflowado: um parágrafo longo que o
 * navegador quebra em quatro linhas conta como uma. É subestimar de propósito — o
 * ajuste fino de quem suporta fica com o `field-sizing: content` do CSS, e para quem
 * não suporta um piso generoso resolve o caso comum.
 */
export const LINHAS_MIN = 6;
export const LINHAS_MAX = 24;

export function linhasDaDescricao(texto: string): number {
  // Sem `|| 1`: uma string vazia tem zero quebras e uma linha, e o piso cobre o caso.
  const quebras = (texto.match(/\n/g) ?? []).length + 1;
  return Math.min(LINHAS_MAX, Math.max(LINHAS_MIN, quebras + 1));
}
